import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChangePasswordComponent } from './change-password.component';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { FormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { DirectiveModule } from '@sportlogiq/main/shared/directive/sl-directive.module';
import { SlLoaderComponent } from '../sl-loader/sl-loader.component';
import { SlButtonTypeDirective } from '@sportlogiq/main/shared/directive/sl-button/sl-button.directive';

@NgModule({
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        DirectiveModule,
        SlLoaderComponent,
        SlButtonTypeDirective
    ],
    declarations: [ChangePasswordComponent],
    exports: [ChangePasswordComponent],
})
export class ChangePasswordModule {}
